import { useNavigation } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React, { useCallback, useContext, useEffect } from "react";
import PrivacyPolicy from "web/components/auth/PrivacyPolicy.component";
import ManagePersonScreen from "web/components/screens/contact-list/ManagePersonScreen.component";
import PersonListScreen from "web/components/screens/contact-list/PersonListScreen.component";
import {
  DASHBOARD_SCREENS,
  SCREEN_ACCOUNT_SETTINGS,
  SCREEN_DASHBOARD_ALERTS,
  SCREEN_DASHBOARD_BCP_INFO,
  SCREEN_DASHBOARD_HOME,
  SCREEN_DASHBOARD_MANAGE_PERSON,
  SCREEN_DASHBOARD_ORGANIZATION_SETTINGS,
  SCREEN_DASHBOARD_OTHER_CONTACTS,
  SCREEN_DASHBOARD_PEOPLE,
  SCREEN_DASHBOARD_PLACES,
  SCREEN_DASHBOARD_PLATFORMS,
  SCREEN_DASHBOARD_TEAMS,
  SCREEN_PRIVACY,
} from "web/constants";
import { AuthContext } from "web/context/Auth.context";
import AlertsScreen from "webComponentsScreens/alerts/AlertsScreen.component";
import BcpInfoScreen from "webComponentsScreens/bcp-info/BcpInfoScreen.component";
import HomeScreen from "webComponentsScreens/dashboard/HomeScreen.component";
import LocationScreen from "webComponentsScreens/locations/LocationScreen.component";
import OrganizationSettingsScreen from "webComponentsScreens/organization-settings/OrganizationSettingsScreen.component";
import OtherContactsScreen from "webComponentsScreens/other-contacts/OtherContactsScreen.component";
import PlatformsScreen from "webComponentsScreens/platforms/PlatformsScreen.component";
import TeamsListScreen from "webComponentsScreens/teams-list/TeamsListScreen.component";
const Stack = createNativeStackNavigator();

const AccountSettingsRedirect = () => {
  const navigation = useNavigation();
  const { userInfo } = useContext(AuthContext);

  useEffect(() => {
    if (userInfo?.personId) {
      const personName =
        userInfo?.firstName && userInfo?.lastName
          ? `${userInfo.firstName} ${userInfo.lastName}`
          : null;

      navigation.navigate(SCREEN_DASHBOARD_MANAGE_PERSON, {
        personId: userInfo.personId,
        personName,
        from: "accountSettingsRedirect",
      });
    }
  }, [navigation, userInfo]);

  return null;
};

export default function DashboardRoutes() {
  const { userInfo } = useContext(AuthContext);
  const getOptions = useCallback(
    (options) => {
      const baseTitle =
        DASHBOARD_SCREENS[options.route.name]?.title ||
        "Business Continuity Portal";
      const title =
        options.route.name === SCREEN_ACCOUNT_SETTINGS &&
        userInfo?.firstName &&
        userInfo?.lastName
          ? `${userInfo.firstName} ${userInfo.lastName}'s ${baseTitle}`
          : options.route.name === SCREEN_DASHBOARD_MANAGE_PERSON &&
              options.route.params?.personName
            ? `Manage ${options.route.params.personName}'s Account`
            : baseTitle;

      return {
        title,
        headerShown: false,
        contentStyle: {
          backgroundColor: "white",
          paddingTop: 30,
        },
      };
    },
    [userInfo],
  );
  return (
    <Stack.Navigator
      initialRouteName={SCREEN_DASHBOARD_HOME}
      screenOptions={(options) => getOptions(options)}
    >
      <Stack.Screen name={SCREEN_DASHBOARD_HOME} component={HomeScreen} />
      <Stack.Screen name={SCREEN_DASHBOARD_ALERTS} component={AlertsScreen} />
      <Stack.Screen
        name={SCREEN_DASHBOARD_PLATFORMS}
        component={PlatformsScreen}
      />
      <Stack.Screen
        name={SCREEN_DASHBOARD_BCP_INFO}
        component={BcpInfoScreen}
      />
      <Stack.Screen name={SCREEN_DASHBOARD_TEAMS} component={TeamsListScreen} />
      <Stack.Screen
        name={SCREEN_DASHBOARD_PEOPLE}
        component={PersonListScreen}
      />
      <Stack.Screen
        name={SCREEN_DASHBOARD_OTHER_CONTACTS}
        component={OtherContactsScreen}
      />
      <Stack.Screen
        name={SCREEN_DASHBOARD_ORGANIZATION_SETTINGS}
        component={OrganizationSettingsScreen}
      />
      <Stack.Screen
        name={SCREEN_ACCOUNT_SETTINGS}
        component={AccountSettingsRedirect}
      />
      <Stack.Screen
        name={SCREEN_DASHBOARD_MANAGE_PERSON}
        component={ManagePersonScreen}
      />
      <Stack.Screen name={SCREEN_PRIVACY} component={PrivacyPolicy} />
      <Stack.Screen name={SCREEN_DASHBOARD_PLACES} component={LocationScreen} />
    </Stack.Navigator>
  );
}
